/** A map of URLS that are shared between backend and frontend */
export const PUBLIC_API_URLS = {
  BAG_ADRESSEERBARE_OBJECTEN:
    'https://api.data.amsterdam.nl/v1/benkagg/adresseerbareobjecten/',
};
